import { Dialog } from 'material-ui';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import { white } from 'material-ui/styles/colors';
import AddFormationIcon from 'material-ui/svg-icons/action/note-add';
import PrintIcon from 'material-ui/svg-icons/action/print';
import moment from 'moment';
import React from 'react';
import { connect } from "react-redux";
import AuthService from '../../../../services/AuthService';
import Alert from "../../../shared/utils/Alert";
import CustomPaper from '../../../shared/utils/CustomPaper';
import FormationForm from '../entretiens/passer_entretien/comps/FormationForm';



class AjouterFormations extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            salarie: { id: 0 },
            isModal1Open: false,
            formationsDuSalarie: []
        };
        this.Auth = new AuthService();
        this.getFormations = this.getFormations.bind(this);
        this.onFormationAdd = this.onFormationAdd.bind(this);
    }

    onFormationAdd(formation) {
        this.setState(prevState => ({
            formationsDuSalarie: [...prevState.formationsDuSalarie, formation]
        }));
        this.getFormations();
    }



    static getDerivedStateFromProps(nextProps, prevState) {
        let toReturn = nextProps.salaries.filter(x => x.id === nextProps.match.params.id_salarie)[0];
        toReturn = toReturn || nextProps.salaries[0];
        for (let key in toReturn) {
            if (toReturn.hasOwnProperty(key) && key.startsWith('date_')) {
                toReturn[key] = new Date(toReturn[key]);
            }
        }

        return { ...prevState, salarie: toReturn };
    }



    getFormations() {
        if (this.state.salarie) {
            let id_salarie = this.state.salarie.id;
            this.Auth.fetch(`/salarie/${id_salarie}/formations`)
                .then(x => this.setState({ formationsDuSalarie: x.data.payload }));
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevState.salarie) {
            this.getFormations();
        } else if (prevState.salarie && prevState.salarie.id !== this.state.salarie.id) {
            this.getFormations();
        }
    }

    render() {
        const salaries = [];
        const formations = this.state.formationsDuSalarie;
        this.props.salaries.map(x => salaries.push(
            <MenuItem key={x.id} value={x.id}
                primaryText={x.nom + " " + x.prenom} />));
        if (salaries.length > 0) {
            return (
                <div className={'container'}>
                    <CustomPaper title='Formations effectuées' >
                        <div className={'row justify-content-center'}>
                            <SelectField
                                value={this.state.salarie.id}
                                floatingLabelText='Salarié concerné par la formation'
                                onChange={(x, y, z) => this.props.history.push('/entreprise/formations/' + z)}
                                maxHeight={400}>
                                {salaries}
                            </SelectField>

                        </div>
                        <RaisedButton
                            label="Imprimer"
                            labelPosition="before"
                            icon={<PrintIcon />}
                            onClick={() => window.print()}
                        />
                        <RaisedButton
                            label="Ajouter une formation"
                            primary={true}
                            style={{ marginLeft: 10 }}
                            labelPosition="before"
                            icon={<AddFormationIcon />}
                            onClick={() => this.setState({ isModal1Open: true })}
                        />
                        <div style={{ marginTop: 10 }}>
                            {

                                (formations.length > 0) ? formations.map((f, index) => (
                                    <table key={index} className={"table table-bordered"}>
                                        <tbody>
                                            <tr>
                                                <th style={{ color: white, backgroundColor: 'blue' }} width="30px" rowSpan="7">{index + 1}</th>
                                                <td style={{ fontWeight: 'bold' }} width="180px">Nom de la formation</td>
                                                <td>{f.nom_formation}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: 'bold' }} >Type</td>
                                                <td>{f.type}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: 'bold' }} >Date de réalisation</td>
                                                <td>{moment(f.date_rea).format('DD/MM/YYYY')}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: 'bold' }} >Durée (Heures)</td>
                                                <td>{f.duree}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: 'bold' }} >Réalisée à l'initiative de</td>
                                                <td>{f.initiateur}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: 'bold' }} >Organisme de la formation</td>
                                                <td>{f.nom_organisme_de_formation || 'Non spécifié.'}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: 'bold' }} >Note de la formation (par le salarié)</td>
                                                <td>{(f.rating === null || f.rating === 0 || f.rating === "0") ? 'Pas encore notée par le salarié.' : (f.rating + "/5 : " + f.rating_comment)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                ))
                                    : <Alert type="warning" text={"Aucune formation n'est renseignée pour " + this.state.salarie.nom} />
                            }
                        </div>
                        <Dialog
                            title="Ajout de formation"
                            modal={false}
                            open={this.state.isModal1Open}
                            onRequestClose={() => this.setState({ isModal1Open: false })}
                            autoScrollBodyContent={true}
                        >
                            <FormationForm id_salarie={this.state.salarie.id} onSuccess={this.onFormationAdd} />
                        </Dialog>
                    </CustomPaper>
                </div>);
        } else {
            return <Alert text="Veuillez d'abord ajouter des salarié." />;
        }
    }
}

function mapStateToProps(store) {
    return {
        salaries: store.entreprise.entreprise_infos.salaries,
        nomEntreprise: store.entreprise.entreprise_infos.nom
    }
}

export default connect(mapStateToProps)(AjouterFormations);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entreprise/AjouterFormations.js